import { dateFromISOString } from '@wz-utilities/date.utilities';
import { arrayToSelectListItemArray } from '@wz-utilities/form.utilities';
import { ClientApiModels } from 'models/api/client-api.models';
import { PolicyApiModels } from 'models/api/policy-api.models';
import { ClientModels } from 'models/client.models';
import { TableModels } from 'models/table.models';
import { PolicyModels } from '../../../../models/policy.models';

export function projectClientTableRowResponse(
  apiResponse: TableModels.PaginatedResult<ClientApiModels.ClientTableRow>,
): TableModels.PaginatedResult<ClientModels.ClientTableRow> {
  return {
    resultCount: apiResponse.resultCount,
    result: apiResponse.result.map((apiClient) => {
      const row: ClientModels.ClientTableRow = {
        ...apiClient,
        creationDate: dateFromISOString(apiClient.creationDate) ?? new Date(),
        dateEffet: dateFromISOString(apiClient.dateEffet) ?? new Date(),
      };

      return row;
    }),
  };
}

export function projectClientResponse(
  apiClient: ClientApiModels.Client,
): ClientModels.Client {
  return {
    broker: apiClient.broker,
    address: apiClient.address,
    civility: apiClient.civility,
    creationDate: dateFromISOString(apiClient.creationDate) ?? new Date(),
    email: apiClient.email,
    mobileNumber: apiClient.mobileNumber,
    phoneNumber: apiClient.phoneNumber,
    firstName: apiClient.firstName,
    lastName: apiClient.lastName,
    nbEscalades: apiClient.nbEscalades,
    policies: arrayToSelectListItemArray<PolicyModels.PolicyRecap>(
      apiClient.policies.map(projectPolicyRecap),
      (p) => ({
        text: p.publicId,
        value: p,
      }),
    ),
    id: apiClient.id,
    publicId: apiClient.publicId,
    creatorAccountId: apiClient.creatorAccountId,
    creatorAccount: apiClient.creatorAccount,
  };
}

export function projectPolicyRecap(
  apiPolicyRecap: PolicyApiModels.PolicyRecap,
): PolicyModels.PolicyRecap {
  return {
    creationDate: dateFromISOString(apiPolicyRecap.creationDate) ?? new Date(),
    id: apiPolicyRecap.id,
    insuranceType: apiPolicyRecap.insuranceType,
    publicId: apiPolicyRecap.publicId,
    status: apiPolicyRecap.status,
    hasRenewal: apiPolicyRecap.hasRenewal,
    quantieme: apiPolicyRecap.quantieme,
    handledBy: apiPolicyRecap.handledBy,
    handledByStartDate:
      dateFromISOString(apiPolicyRecap.handledByStartDate) ?? new Date(),
    handledById: apiPolicyRecap.handledById!,
    isDocumentJobAutoAssigned: apiPolicyRecap.isDocumentJobAutoAssigned,
    packageId: apiPolicyRecap.packageId,
  };
}
